import { lazy } from 'react';

import DashboardLayout from 'layout/Dashboard';
import PagesLayout from 'layout/Pages';
import Loadable from 'components/Loadable';

const AuthLogin = Loadable(lazy(() => import('pages/auth/login')));

const AppLiveStream = Loadable(lazy(() => import('pages/livestream/list')));
const AppStreamsList = Loadable(lazy(() => import('pages/stream/list')));
const AppParentsList = Loadable(lazy(() => import('pages/parents/list')));
const AppClassRooms = Loadable(lazy(() => import('pages/classrooms/list')));

const MainRoutes = {
  path: '/',
  children: [
    {
      path: '/',
      element: <DashboardLayout />,
      children: [
        {
          path: 'streams',
          element: <AppStreamsList />
        },
        {
          path: 'parents',
          element: <AppParentsList />
        },
        {
          path: 'classrooms',
          element: <AppClassRooms />,
        },
        {
          path: 'livestream',
          element: <AppLiveStream />,
        },
      ]
    },
    {
      path: '/auth',
      element: <PagesLayout />,
      children: [
        {
          path: 'login',
          element: <AuthLogin />
        }
      ]
    }
  ]
};

export default MainRoutes;
